
import { APPEAL_DATA_REQUEST, APPEAL_DATA_FAILURE, APPEAL_DATA_SUCCESS, APPEAL_DETAILS_DATA_REQUEST, APPEALS_TOP_OVERTURN_REASON_DATA_REQUEST, APPEALS_TOP_OVERTURN_REASON_DATA_FAILURE, APPEALS_TOP_OVERTURN_REASON_DATA_SUCCESS, APPEALS_TREND_DATA_FAILURE, APPEALS_TREND_DATA_LOADING, APPEALS_TREND_DATA_REQUEST, APPEALS_TREND_DATA_SUCCESS, APPEALS_TOP_OVERTURN_REASON_DATA_LOADING } from "../actionTypes"

export const fetchAppealDataRequest = (payload: any) => ({
    type: APPEAL_DATA_REQUEST,
    payload
});

export const fetchAppealDataSuccess = (payload: any) => ({
    type: APPEAL_DATA_SUCCESS,
    payload
});

export const fetchAppealDataError = (payload: any) => ({
    type: APPEAL_DATA_FAILURE,
    payload
});


export const fetchAppealTopOverturnDataRequest = (payload: any) => ({
    type: APPEALS_TOP_OVERTURN_REASON_DATA_REQUEST,
    payload
});

export const fetchAppealTopOverturnDataLoading = (payload: any) => ({
    type: APPEALS_TOP_OVERTURN_REASON_DATA_LOADING,
    payload
});

export const fetchAppealTopOverturnDataSuccess = (payload: any) => ({
    type: APPEALS_TOP_OVERTURN_REASON_DATA_SUCCESS,
    payload
});
export const fetchAppealTopOverturnDataError = (payload: any) => ({
    type: APPEALS_TOP_OVERTURN_REASON_DATA_FAILURE,
    payload
});

export const fetchAppealDetailsDataRequest = (payload: any, key: string) => ({
    type: APPEAL_DETAILS_DATA_REQUEST,
    key,
    payload,
  });

  export const fetchAppealTrendDataRequest = (payload: any) => ({
    type: APPEALS_TREND_DATA_REQUEST,
    payload
});

export const fetchAppealTrendDataSuccess = (payload: any) => ({
    type: APPEALS_TREND_DATA_SUCCESS,
    payload
});

export const fetchAppealTrendDataLoading = (payload: any) => ({
    type: APPEALS_TREND_DATA_LOADING,
    payload
});

export const fetchAppealTredDataError = (payload: any) => ({
    type: APPEALS_TREND_DATA_FAILURE,
    payload
});